export enum AcEnumDDTableRowOperation {
  delete = "delete",
  format = "format",
  insert = "insert",
  save = "save",
  select = "select",
  update = "update",
}
